if (!customElements.get('diamond-actions')) {
  window.DiamondActions = class DiamondActions extends HTMLElement {
    constructor() {
      super();
      this.moreInfoBtn = this.querySelector('[data-action="more-info"]');
      this.certNumber = this.dataset.certNumber;
      this.title = this.dataset.title;
      this.diamondUrl = this.dataset.diamondUrl;
      this.handle = this.dataset.handle;
      this.submitBtn = this.querySelector('[data-action="select"]');
      window.journey_start_with = window.journey_start_with || 'diamond';
      const tracker = document.querySelector('[data-journey-start-with]');
      if (tracker) {
        const startWith = tracker.dataset.journeyStartWith;
        if (startWith) window.journey_start_with = startWith;
      }

      if (this.moreInfoBtn) this.moreInfoBtn.addEventListener('click', this.moreInfoHandler.bind(this));
      if (this.submitBtn) this.submitBtn.addEventListener('click', this.submit.bind(this));
      
      // Add pageshow event listener to handle page load from cache
      window.addEventListener('pageshow', this.handlePageShow.bind(this));
    }

    connectedCallback() {
      const card = this.closest('.diamond-card');
      if (!document.location.href.includes('products/') && card) {
        card.addEventListener('mouseover', this.fetchLatestDiamonds.bind(this), {
          once: true,
        });
      }
    }

    async fetchLatestDiamonds() {
      this.diamondProduct = await DiamondActions.fetchDiamondProduct({ certNumber: this.certNumber });
    }

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    moreInfoHandler(evt) {
      evt.preventDefault();
      DiamondActions.showOverlay();

      DiamondActions.createDiamondProduct({ certNumber: this.certNumber, redirect: true }); // it will redirect to the product page
    }

    async submit() {
      const diamond = {
        handle: this.handle,
        shape: this.dataset.shape,
        timestamp: Date.now(),
      };
      const shape = this.dataset.shape;
      const type = this.dataset.type;
      DiamondActions.showOverlay();
      await DiamondActions.selectHandler({ diamond, shape, type });
    }

    static async selectHandler({ diamond, shape: shape_, type }) {
      //const shape = this.capitalize(shape_).split(' ')[0];
      //const ringsCollectionUrl = `${window.theme.rings_collection_url}?&filter.p.m.custom.ring_shape=${shape}&type=${type.toLowerCase()}&view=diamonds-journey-rings`;
      const shape = (shape_ ? shape_ : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`] /* + '?view=diamonds-journey-rings' */;
      if (!window[`${shape}_collection_url`]) {
        return alert(`make sure that collection for ${shape} is active`);
      }

      const attributes = Object.fromEntries(Object.entries(diamond).map(([key, value]) => [`diamond_${key}`, value])); // { diamond_handle: diamond.handle, diamond_shape: diamond.shape, diamond_timestamp: diamond.timestamp }

      if (window.journey_start_with == 'diamond') {
        attributes.rings_collection_url = shapeCollectionUrl;
      }

      try {
        const promises = [DiamondActions.updateCartAttrs({ attributes })];

        if (!window.location.href.includes('products/'))
          promises.push(DiamondActions.createDiamondProduct({ certNumber: diamond.handle.replace('diamond-', ''), redirect: false }));

        const [cartData, diamondData] = await Promise.all(promises);

        /* console.log('diamondData', diamondData);
        console.log('product_handle', diamondData?.product_handle);
        console.log('Cart updated', cartData); */
        const ring_shape_down = cartData.attributes.ring_shape?.toLowerCase().replaceAll(' ', '_');
        const diamond_shape_down = cartData.attributes.diamond_shape?.toLowerCase().replaceAll(' ', '_');
        if (ring_shape_down == diamond_shape_down && cartData.attributes.diamond_handle) {
          return (window.location.href = window.complete_engagement_ring_url);
        }
        if (window.journey_start_with == 'diamond') {
          window.location.href = shapeCollectionUrl + `?journey_start_with=`;
        } else {
          window.location.href = window.complete_engagement_ring_url;
        }
      } catch (error) {
        console.error('Cart update failed:', error);
      }
    }

    static async createDiamondProduct({ certNumber, redirect = true }) {
      const handle = `diamond-${certNumber}`;
      const url = window.diamonds_route + `/products/check/${handle}`;
      const data = await DiamondActions.fetchDiamondProduct({ certNumber });
      //if (!data) console.error('Product not found');
      if (redirect) {
        DiamondActions.checkAndRedirect(`${theme.routes.root_url}products/${handle}`);
        //window.location.href = `${theme.routes.root_url}products/${handle}`;
      } else {
        return data;
      }
    }

    static async fetchDiamondProduct({ certNumber }) {
      if (this.diamondProduct) {
        return this.diamondProduct;
      }
      const handle = `diamond-${certNumber}`;
      const url = window.diamonds_route + `/products/check/${handle}`;
      return fetch(url)
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.error('Product check failed', error);
          //alert('An error occurred while trying to view the product. Please try again.');
        });
    }

    static async updateCartAttrs({ attributes }) {
      const maxRetries = 3;
      let retryCount = 0;
      let lastError = null;

      while (retryCount < maxRetries) {
        try {
          const response = await fetch(`${theme.routes.cart_update_url}.js`, {
            method: 'POST',
            body: JSON.stringify({
              attributes,
            }),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          
          return await response.json();
        } catch (error) {
          lastError = error;
          console.warn(`Cart update attempt ${retryCount + 1} failed:`, error.message);
          retryCount++;
          
          if (retryCount < maxRetries) {
            // Wait with exponential backoff before retrying (300ms, 600ms, 1200ms)
            await new Promise(resolve => setTimeout(resolve, 300 * Math.pow(2, retryCount - 1)));
          }
        }
      }
      
      // All retries failed
      console.error(`Cart update failed after ${maxRetries} attempts:`, lastError);
      throw new Error(lastError.message || "Failed to update cart after multiple attempts");
    }

    static showOverlay({ msg = 'Preparing your diamond ...' } = {}) {
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = msg;
      }
      if (overlay) {
        overlay.style.display = 'block';
      }
    }

    static hideOverlay() {
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay?.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = '';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
    }

    disconnectedCallback() {
      this.hideOverlay();
    }

    hideOverlay() {
      // let's hide the overlay
      // and revert the submit button
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = '';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
      //this.submitBtn.removeAttribute('disabled');
    }

    static async checkAndRedirect(url, retries = 10, delay = 500) {
      for (let i = 0; i < retries; i++) {
        try {
          const response = await fetch(url, { method: 'HEAD' });
          console.log('response', response);
          if (response.ok) {
            // If the status is 200-299, proceed with redirect
            window.location.href = url;
            return;
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }

        // Wait before retrying if not successful
        if (i < retries - 1) {
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      }

      console.error(`Failed to load the URL after ${retries} attempts.`);
    }

    // Handle page load from cache (bfcache)
    handlePageShow(event) {
      // Check if the page was loaded from the browser cache (bfcache)
      if (event.persisted) {
        this.hideOverlay();
      }
    }
  };

  window.customElements.define('diamond-actions', DiamondActions);
}
